import { Answer } from "../Model/Answer";
import { Resume } from "../Model/Resume";
export class AnswersService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOne(AnswerId) {
        if (AnswerId) {
            const response = await this.apiService.get('answer/' + AnswerId);
            if (!response.ok) {
                throw new Error(`Error al obtener la respuesta.`);
            }
            const content = await response.json();
            if (content) {
                const answer = new Answer(content);
                return answer;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener AnswerId.`);
        }
    }
    async findByUser(userId) {
        const response = await this.apiService.get('answer-by-user/' + userId);
        if (response.status == 404) {
            return null;
        }
        if (!response.ok) {
            throw new Error(`Error al obtener la respuesta.`);
        }
        const content = await response.json();
        const answer = new Answer(content);
        return answer;
    }
    async findAnswers() {
        const response = await this.apiService.get(`answers`);
        if (!response.ok) {
            throw new Error(`Error al obtener las preguntas.`);
        }
        const content = await response.json();
        return content.map(answer => new Answer(answer).getState());
    }
    async findResume() {
        const response = await this.apiService.get(`resume`);
        if (!response.ok) {
            throw new Error(`Error al obtener los resumenes.`);
        }
        const content = await response.json();
        return content.map(resume => new Resume(resume).getState());
    }
    async saveAnswer(answer) {
        if (answer) {
            const response = await this.apiService.post('answer', answer.getState());
            if (!response.ok) {
                throw new Error(`Error al guardar la respuesta.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
}
